import { createFileRoute, redirect } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { BrandMark } from "@/components/layout/BrandMark"
import { LoginForm } from "@/features/auth/components/LoginForm"
import { useAuthStore } from "@/features/auth/store"

export const Route = createFileRoute("/login")({
  beforeLoad: () => {
    if (useAuthStore.getState().isAuthenticated()) {
      throw redirect({ to: "/dashboard" })
    }
  },
  component: LoginPage,
})

function LoginPage() {
  const { t } = useTranslation("auth")
  return (
    <div className="min-h-screen grid place-items-center bg-ok-bg p-6">
      <div className="w-full max-w-md space-y-6">
        <div className="text-center space-y-3">
          <BrandMark size="lg" className="block" />
          <h1 className="text-2xl font-semibold tracking-tight">{t("login.title")}</h1>
          <p className="text-sm text-ok-foreground-muted">{t("login.subtitle")}</p>
        </div>
        <div className="rounded-ok-lg border border-ok-border bg-ok-bg-subtle p-6 shadow-ok-sm">
          <LoginForm />
        </div>
      </div>
    </div>
  )
}
